import { Injectable } from '@angular/core';
import { InternalDatabaseService } from '../internal/internal-database.service';
import { User } from './user';

@Injectable({
  providedIn: 'root'
})
export class UserStorageService {
  readonly table: string;
  readonly usernameIndex: string;

  constructor(private internalDatabaseService: InternalDatabaseService) {
    const table = User.getTableDefinition();
    this.table = table.TableName;
    this.usernameIndex = table.Indexes[0].Name;
  }

  async addUser(user: User): Promise<string> {
    const key = await this.internalDatabaseService.add(this.table, user);
    return key.toString();
  }

  async saveUserPin(username: string, pin: string): Promise<string> {
    const user = await this.getUserByUsername(username);
    user.Pin = pin;
    const key = await this.internalDatabaseService.update(this.table, user);
    return key.toString();
  }

  async deleteUser(userId: number): Promise<void> {
    await this.internalDatabaseService.delete(this.table, userId);
  }

  async getUserById(id: number): Promise<User> {
    return await this.internalDatabaseService.getByPrimaryKey<User>(
      this.table,
      id
    );
  }

  async getUserByUsername(username: string): Promise<User> {
    return await this.internalDatabaseService.getByIndex<User>(
      this.table,
      this.usernameIndex,
      username.toLowerCase()
    );
  }

  async getAllUsers(): Promise<User[]> {
    return await this.internalDatabaseService.getAll<User>(this.table);
  }

  async getAllKeys(): Promise<string[]> {
    return await this.internalDatabaseService.getAllKeys(this.table);
  }

  async updateUser(user: User): Promise<{}> {
    await this.internalDatabaseService.update(this.table, user);
    return true;
  }

  updateUserLoggedInDate(user: User): void {
    user.LastLoggedInDate = new Date();
    this.internalDatabaseService.update(this.table, user);
  }

  async createNewUser(token: string, username: string): Promise<{}> {
    const user = new User();
    user.LastAuthenticationDate = new Date();
    user.LastLoggedInDate = new Date();
    user.Pin = null;
    user.Token = token;
    user.Username = username;

    return this.addUser(user);
  }

  async checkUserExistsInDb(username: string) {
    return await this.getUserByUsername(username);
  }
}
